import {Mesh} from '../../index.js';

/**
 * Creates Hypercube.js plane meshes.
 * @example
 * const meshplane = new MeshPlane(name, lengths);
 */
class MeshPlane extends Mesh {

    /**
     * Stores the memoized data.
     * @type {Object.<string, number[]>}
     * @private
     * @readonly
     * @static
     */
    static $memory = {};

    /**
     * Stores the indices.
     * @type {number[]}
     * @protected
     */
    $indices = [

        // -y face
        0, 1, 2,
        2, 3, 0,

        // +y face
        4, 5, 6,
        6, 7, 4
    ];

    /**
     * Stores the normals.
     * @type {number[]}
     * @protected
     */
    $normals = [

        // -y face
        0, -1, 0,
        0, -1, 0,
        0, -1, 0,
        0, -1, 0,

        // +y face
        0, 1, 0,
        0, 1, 0,
        0, 1, 0,
        0, 1, 0
    ];

    /**
     * Creates a new Hypercube.js plane mesh.
     * @param {string} $name The name of the mesh to create.
     * @param {[number, number]} $lengths The lengths of the plane to create.
     */
    constructor($name, $lengths) {

        super($name);

        this.$type = 'mesh.plane' + JSON.stringify($lengths);

        if (MeshPlane.$memory.hasOwnProperty(this.$type) === false) {

            MeshPlane.$memory[this.$type] = this.$createpositions([...$lengths]);
        }

        this.$positions = [...MeshPlane.$memory[this.$type]];
    }

    /**
     * Creates the positions.
     * @param {[number, number]} $lengths The lengths of the plane to create.
     * @returns {number[]}
     * @private
     */
    $createpositions($lengths) {

        const [xlength, zlength] = $lengths;

        const xlengthhalved = xlength * 0.5;
        const zlengthhalved = zlength * 0.5;

        return [

            // -y face
            - xlengthhalved, 0, - zlengthhalved,
            - xlengthhalved, 0, zlengthhalved,
            xlengthhalved, 0, zlengthhalved,
            xlengthhalved, 0, - zlengthhalved,

            // +y face
            - xlengthhalved, 0, - zlengthhalved,
            xlengthhalved, 0, - zlengthhalved,
            xlengthhalved, 0, zlengthhalved,
            - xlengthhalved, 0, zlengthhalved
        ];
    }
}

export {

    MeshPlane
};

export default MeshPlane;
